import{mergeMap as r}from"./mergeMap.js";function e(e,o){return r(e,o,1)}export{e as concatMap};
